import React from 'react';
import RedireccionarALanding from './RedireccionarALanding';
import Breakdown from '../views/Breakdown';

export const route = [
    {path: '/:language/:bookingCode?', componente: Breakdown, exact: false},
    { path: '*', element: React.createElement(RedireccionarALanding), exact: false },
  ];